import Image from "next/image";
import Link from "next/link";
import React from "react";

interface Props {
  data: any;
  current: number;
  changePage: (index: number) => void;
}

const PostPagination: React.FC<Props> = ({ data, current, changePage }) => {
  const handlePage = (e: any, index: number) => {
    e.preventDefault();
    if (index >= 0 && index < data) changePage(index);
  };

  const generatePageNumbers = () => {
    const totalPages = data;
    const currentPage = current;
    const pages = [];

    if (totalPages <= 7) {
      // Show all pages if total is 7 or less
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(0);

      if (currentPage <= 3) {
        // Current page is near the beginning
        for (let i = 1; i < 5; i++) {
          pages.push(i);
        }
        pages.push("ellipsis-end");
        pages.push(totalPages - 1);
      } else if (currentPage >= totalPages - 4) {
        // Current page is near the end
        pages.push("ellipsis-start");
        for (let i = totalPages - 5; i < totalPages - 1; i++) {
          pages.push(i);
        }
        pages.push(totalPages - 1);
      } else {
        // Current page is in the middle
        pages.push("ellipsis-start");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("ellipsis-end");
        pages.push(totalPages - 1);
      }
    }

    return pages;
  };

  const pageNumbers = generatePageNumbers();

  return (
    <>
      {/* Pagination */}
      <ul className="flex items-center space-x-2 justify-center pagination my-[20px] md:mt-[40px] flex-wrap gap-3">
        {/* Previous */}
        <li>
          <button
            disabled={current === 0}
            onClick={(e: any) => handlePage(e, current - 1)}
            className={`w-[46px] h-[46px] flex items-center justify-center border-[#464953] border bg-[#0b0b0d] hover:bg-[#32343B] hover:border-[#7EAB00] ${current === 0 ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
          >
            <Image
              src="/images/pagi-arro-left.svg"
              alt="previous"
              width={20}
              height={20}
              className="object-cover block w-[20px] h-[20px] invert"
            />
          </button>
        </li>

        {/* Page Numbers with Ellipsis */}
        {pageNumbers.map((item: any, index: number) => {
          if (item === "ellipsis-start" || item === "ellipsis-end") {
            return (
              <li key={`ellipsis-${index}`}>
                <span className="w-[46px] h-[46px] flex items-center justify-center border-[#464953] border bg-[#0b0b0d] font-[400] tracking-[1px] text-[12px] leading-[16.8px] xl:text-[14px] xl:leading-[19.6px] text-gray-400">
                  ...
                </span>
              </li>
            );
          }

          return (
            <li key={index}>
              <Link
                aria-current={current === item ? "page" : undefined}
                onClick={(e: any) => handlePage(e, item)}
                href={"?page=" + (item + 1)}
                className={`w-[46px] h-[46px] flex items-center justify-center border-[#464953] border bg-[#0b0b0d] hover:bg-[#32343B] hover:border-[#7EAB00] font-[400] tracking-[1px] text-[12px] leading-[16.8px] xl:text-[14px] xl:leading-[19.6px] text-white active:text-[#7EAB00] active:font-[700] ${
                  current === item
                    ? "!bg-[#7EAB00] !border-[#7EAB00] !text-white"
                    : ""
                }`}
              >
                {item + 1}
              </Link>
            </li>
          );
        })}

        {/* Next */}
        <li>
          <button
            disabled={current + 1 === data}
            onClick={(e: any) => handlePage(e, current + 1)}
            className={`w-[46px] h-[46px] flex items-center justify-center border-[#464953] border bg-[#0b0b0d] hover:bg-[#32343B] hover:border-[#7EAB00] ${current + 1 >= data ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
          >
            <Image
              src="/images/pagi-arro-right.svg"
              alt="next"
              width={20}
              height={20}
              className="object-cover block w-[20px] h-[20px] invert"
            />
          </button>
        </li>
      </ul>
    </>
  );
};

export default PostPagination;
